// @ts-nocheck

export const OK = 'OK';
export const EMPTY = 'EMPTY';
export const PENDING = 'PENDING';
export const VALIDATED = 'VALIDATED';
export const WAITING_TRADER_VALIDATION = 'WAITING_TRADER_VALIDATION';
export const ERROR = 'ERROR';

export default {
  OK,
  EMPTY,
  PENDING,
  VALIDATED,
  WAITING_TRADER_VALIDATION,
  ERROR,
};
